import { useNavigation } from "@luce/core/adapters/navigation";
import { Card, Skeleton } from "@luce/ui";

import { useClientAddresses } from "../../client-address/gqlhooks/use-client-addresses";
import { InfoSection } from "./components/info-section";

export function AccountInfoDefaultAddress() {
  const { push } = useNavigation();
  const { addressLists, loading } = useClientAddresses();

  const primaryAddress = addressLists.find((address) => address.isPrimary);

  return (
    <InfoSection title="Default Address" onViewAll={() => push("/profile/addresses")}>
      {loading && <Skeleton radius="lg" className="h-20 w-full" />}
      {!loading && primaryAddress && (
        <Card direction="row" gap="sm">
          <Card.Header>
            <Card.Title>{primaryAddress.header}</Card.Title>
            {primaryAddress.body ? (
              <Card.Description>{primaryAddress.body}</Card.Description>
            ) : null}
          </Card.Header>
        </Card>
      )}
    </InfoSection>
  );
}
